import React, { useEffect, useState } from "react";
import { Table, Typography, Button, Input } from "antd";
import { LeftOutlined } from "@ant-design/icons";
import { useLocation, useNavigate } from "react-router-dom";
import colors from "../assets/styles/colour";
import CustomTable from "../components/TableComponent/CustomTable";

function AllLevelElectionPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const [columns, setColumns] = useState([]);
  const [dataSource, setDataSource] = useState([]);
  const electionDetails = location.state?.electionDetails || [];
  const yearSelected = location.state?.yearSelected || null;
  const firstDropDown = location.state?.firstDropDown || null;
  const secondDropDown = location.state?.secondDropDown || null;

  const [filteredData, setFilteredData] = useState([]);

  useEffect(() => {
    if (electionDetails.length > 0) {
      const dynamicColumns = Object.keys(electionDetails[0])
        .filter((key) => !key.endsWith("_bgColor"))
        .map((key) => ({
          title: key,
          dataIndex: key,
          key,
          render: (text, record) => {
            // Apply background color
            const bgColor = record[`${key}_bgColor`];

            // Check if text is a number and format it to 2 decimal places
            const formattedText =
              typeof text === "number"
                ? Number.isInteger(text)
                  ? text // Keep whole numbers as they are
                  : text.toFixed(2) // Format decimal numbers to 2 decimal places
                : text;

            return (
              <div
                style={{
                  backgroundColor: bgColor || "transparent",
                  padding: "5px",
                  borderRadius: "4px",
                  height: "4vh",
                }}
              >
                {formattedText}
              </div>
            );
          },
        }));

      setColumns(dynamicColumns);
      setDataSource(electionDetails);
    }
  }, [electionDetails]);
  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();

    const filtered = electionDetails.filter((item) =>
      Object.keys(item).some(
        (key) =>
          typeof item[key] === "string" &&
          item[key].toLowerCase().includes(value)
      )
    );

    setFilteredData(filtered);
  };

  return (
    <div style={{ padding: "20px" }}>
      {/* Go Back Button */}
      <Button
        type="primary"
        icon={<LeftOutlined />}
        onClick={() => {
          if (secondDropDown && firstDropDown) {
            navigate("/login/parliament-election-details", {
              state: {
                yearSelectedValue: yearSelected,
                firstDropDownValue: firstDropDown,
                secondDropDownValue: secondDropDown,
              }, // Pass the data dynamically
            });
          } else if (firstDropDown) {
            navigate("/login/assembly-election-details", {
              state: {
                yearSelectedValue: yearSelected,
                firstDropDownValue: firstDropDown,
                secondDropDownValue: secondDropDown,
              }, // Pass the data dynamically
            });
          } else {
            navigate(-1);
          }
          // navigate("/login/assembly-election-details", {
          //   state: {
          //     yearSelectedValue: yearSelected,
          //     firstDropDownValue: firstDropDown,
          //     secondDropDownValue: secondDropDown,
          //   }, // Pass the data dynamically
          // });

          // navigate(-1)
        }}
        style={{ marginBottom: "5px" }}
      >
        Go Back
      </Button>

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "20px",
          margin: "10px",
        }}
      >
        <Typography.Title level={3} style={{ margin: 0 }}>
          Election Details
        </Typography.Title>
        <Input.Search
          placeholder="Search by Name"
          onChange={handleSearch}
          style={{ width: 200 }}
        />
      </div>

      <CustomTable
        columns={columns}
        dataSource={filteredData.length > 0 ? filteredData : electionDetails}
        rowKey={(record) => record.key}
        pagination={{ pageSize: 10 }}
        style={{
          boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
          borderRadius: "8px",
          backgroundColor: "#fff",
          width: "100%",
          height: "60vh",
          // overflowX: "auto",
        }}
        // scroll={{ x: 800 }}
      />
    </div>
  );
}

export default AllLevelElectionPage;
